import { styled, Typography } from '@mui/material';

export const ContainerW = styled('div')`
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 42px;
  padding: 23px 24px 10px 24px;
  @media (max-width: 1023px) {
    margin-bottom: 24px;
  }
`;

export const Title = styled(Typography)`
  font-size: 16px;
  font-weight: 700;
  line-height: 18px;
  color: ${({ theme }) => theme.palette.primary.p020};
  padding-bottom: 6px;
  @media (max-width: 1023px) {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
  }
`;

export const Row = styled('div')`
  display: flex;
  color: ${({ theme }) => theme.palette.primary.p080};
  padding: 24px 0;
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};

  &:last-of-type {
    border-bottom: none;
  }
  @media (max-width: 1023px) {
    flex-direction: column;
    padding: 16px 0;
  }
`;

export const LabelW = styled('div')`
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  width: 50%;
  min-width: 50%;

  @media (max-width: 1023px) {
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    color: rgba(0, 0, 0, 0.4);
  }
`;

export const Label = styled('div')`
  overflow-wrap: break-word;
  white-space: break-spaces;
`;

export const Value = styled('div')`
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  word-break: break-word;
  color: ${({ theme }) => theme.palette.info.main};
  & p {
    margin: 12px 0;

    &:has(code) {
      margin: 4px 0;
    }

    &:first-of-type {
      margin-top: 0;
    }
  }

  & a {
    color: ${({ theme }) => theme.palette.info.main};
  }

  @media (max-width: 1023px) {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    margin-top: 16px;
  }
`;
